module.exports = __webpack_public_path__ + "media/images/area/feature/banner/pc/en_tohoku-6e1bcf7f6b69d931395ef86626208e3e.jpg";